import { combineReducers } from 'redux';

import {
  REQUEST_USER_SUCCESS,
  REQUEST_ACCOUNT_SUCCESS,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
} from '../actions/users'
import {
  GAPI_SIGNEDIN,
  GAPI_SIGNEDOUT
} from '../actions/gapi'

import {
  CREATE_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_ERROR,
  CREATE_SUBSCRIPTION_SUCCESS,
  REQUEST_SUBSCRIPTION_USERS_SUCCESS,
  INVITE_USERS_ERROR,
  ADD_USER_ERROR,
  REMOVE_USER_SUCCESS,
  DISMISS_SUBSCRIPTION_WARNING_SUCCESS,
  REQUEST_SUBSCRIPTION_SUCCESS,
} from '../actions/subscriptions';

import { CLEAR_ERRORS } from '../actions/messages';

import { AUTH_PROVIDER_GOOGLE } from '../constants';
import {
  REQUEST_LICENCES_SUCCESS,
  REQUEST_USER_PRODUCT_LICENCE_SUCCESS
} from '../actions/licences';
import {
  ACCEPT_INVITATION_ERROR,
  ACCEPT_INVITATION_SUCCESS
} from '../actions/invitations';
//import { update, remove } from './common';

import invitationsById from './invitations';
import domainsById from './domains';
import pendingDomainInvitations from './pendingDomainInvitations';
import subscriptionsById from './subscriptions';
import productsById, {currentProduct, planTargetPeriodicity} from './products';
import messages from './messages';

function googleUser(state = null, action) {
  switch (action.type) {
    case GAPI_SIGNEDIN:
      return action.googleUser;
    case GAPI_SIGNEDOUT:
      return null;
    default:
      return state;
  }
}

function usersById(state = {}, action) {
  switch (action.type) {
    case REQUEST_USER_SUCCESS:
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        [action.user.id]: action.user
      }
    case REQUEST_SUBSCRIPTION_USERS_SUCCESS:
      return action.items.reduce((state, item) => ({
        ...state,
        [item.id]: item
      }), state);
    default:
      return state;
  }
}

function accountsByUserId(state = {}, action) {
  switch (action.type) {
    case REQUEST_ACCOUNT_SUCCESS:
      return {
        ...state,
        [action.userId]: action.account,
      };
    case CREATE_SUBSCRIPTION_SUCCESS:
      // add subscription to account after creation success
      // FIXME: normalize
      const account = state[action.accountId];
      if (account) {
        const newAccount = {
          ...account,
          subscriptions: (account.subscriptions || []).concat([action.subscription])
        }
        return {
          ...state,
          [action.accountId]: newAccount
        }
      }
      return state;
    case DISMISS_SUBSCRIPTION_WARNING_SUCCESS:
      // remove the warning from the associated subscription embedded in account
      return Object.keys(state).reduce((result, accountId) => {
        result[accountId] = {
        ...state[accountId],
        subscriptions: !state[accountId].subscriptions ? [] : state[accountId].subscriptions.map(subscription => 
          subscription.id === action.subscriptionId
            ? {
                ...subscription,
                warnings: subscription.warnings.filter(warning => warning.id !== action.alertId)
              }
            : subscription)
      }
        return result
      }, {});
    case REQUEST_SUBSCRIPTION_SUCCESS:
        return Object.keys(state).reduce((result, accountId) => {
          result[accountId] = {
          ...state[accountId],
          subscriptions: !state[accountId].subscriptions ? [] : state[accountId].subscriptions.map(subscription => 
            subscription.id === action.subscription.id
              ? action.subscription
              : subscription
              )
        }
          return result
        }, {});
    default:
      return state;
  }
}

function licencesByProductId(state = {}, action) {
  switch (action.type) {
    case ACCEPT_INVITATION_SUCCESS:
    case REQUEST_USER_PRODUCT_LICENCE_SUCCESS:
      return {
        ...state,
        [action.licence.plan.product.id]: action.licence
      };
    case REQUEST_LICENCES_SUCCESS:
      if( !action.items ) {
        return state;
      }
      return action.items.reduce((memo, licence) => {
        memo[licence.plan.product.id] = action.licence;
        return memo;
      }, {...state});

    case REMOVE_USER_SUCCESS:
      // find the corresponding product, and remove the state's entry
      const productId = Object.keys(state).find( productId => 
        state[productId].subscriptionId === action.subscriptionId
      );

      if ( productId ) {
        delete state[productId];
        return {...state}
      }
      return state;

    default:
      return state;
  }
}

function licencesByUserId(state = {}, action) {
  if( action.userId ) {
    return {
      ...state,
      [action.userId]: licencesByProductId(state[action.userId], action)
    }
  }
  return state;
}

function creatingUser(state = false, action) {
  switch (action.type) {
    case CREATE_USER:
      return true;
    case CREATE_USER_SUCCESS:
      return false;
    default:
      return state;
  }
}

function errors(state = [], action) {
  switch (action.type) {
    case CREATE_USER_ERROR:
    case CREATE_SUBSCRIPTION_ERROR:
    case ACCEPT_INVITATION_ERROR:
    case INVITE_USERS_ERROR:
    case ADD_USER_ERROR:
      if (action.error.errors) {
        return state.concat(action.error.errors);
      } else {
        return state.concat([action.error]);
      }
    case CLEAR_ERRORS:
      return [];
    default:
      return state;
  }
}

function currency() {
  return {
    symbol: '$',
    code: 'USD'
  };
}

function creatingSubscription(state = false, action) {
  switch( action.type ) {
    case CREATE_SUBSCRIPTION:
      return true;
    case CREATE_SUBSCRIPTION_ERROR:
    case CREATE_SUBSCRIPTION_SUCCESS:
      return false;
    default: 
      return state;
  }
}

export function login({ usersById, googleUser }) {
  if (!googleUser) {
    return null;
  }
  return Object.values(usersById).find(user =>
    user.authProvider === AUTH_PROVIDER_GOOGLE
    && user.authId === googleUser.id
  );
}


export default combineReducers({
  usersById,
  googleUser,
  productsById,
  accountsByUserId,
  licencesByUserId,
  invitationsById,
  creatingUser,
  errors,
  currency,
  subscriptionsById,
  messages,
  currentProduct,
  domainsById,
  pendingDomainInvitations,
  creatingSubscription,
  planTargetPeriodicity
});



// WEBPACK FOOTER //
// ./src/reducers/index.js